var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Observable, observe, Scope } from 'wdc-cube';
/** Um atalho na lista, e se e o que esta em vigor. */
let PeriodOptionScope = class PeriodOptionScope extends Scope {
    constructor() {
        super(...arguments);
        this.label = '';
        /** O nome curto, para quem desenha fileira - ver `PERIOD_SHORT_LABELS`. */
        this.shortLabel = '';
        this.value = '';
        this.current = false;
        this.onSelect = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], PeriodOptionScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], PeriodOptionScope.prototype, "shortLabel", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], PeriodOptionScope.prototype, "value", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], PeriodOptionScope.prototype, "current", void 0);
PeriodOptionScope = __decorate([
    Observable
], PeriodOptionScope);
export { PeriodOptionScope };
/**
 * O que a view do seletor de periodo desenha.
 *
 * ## `from` e `to` estao SEMPRE preenchidos
 *
 * Mesmo com um atalho escolhido. Sao o intervalo EM VIGOR, e nao "o que alguem
 * digitou": e o que permite a tela mostrar as duas datas o tempo todo, e o que faz
 * escolher "Últimos 30 dias" responder ali mesmo que dias aquilo significa.
 *
 * Antes deste componente, as quatro telas que escolhem periodo escondiam as datas
 * atras da opcao "personalizado" - e quem escolhia um atalho nao tinha como saber o
 * intervalo sem contar nos dedos.
 */
let PeriodScope = class PeriodScope extends Scope {
    constructor() {
        super(...arguments);
        this.options = [];
        /** O rotulo do atalho em vigor, para o gatilho da lista fechada. */
        this.summary = '';
        this.from = '';
        this.to = '';
        /**
         * Se ha RECORTE de data em vigor.
         *
         * Falso em "Todo o periodo", e so nele: os outros atalhos todos produzem intervalo.
         * Existe porque o seletor mostra um texto o tempo todo - e um combo sempre tem
         * resumo -, e "Todo o periodo" escrito com o mesmo peso de "Últimos 30 dias" LE
         * como filtro aplicado. Na lista de Colaboradores isso ficou visivel ao lado dos
         * combos vizinhos, que apagam o texto quando estao vazios: o periodo era o unico
         * controle que parecia sempre preenchido.
         *
         * Quem nao oferece "Todo o periodo" - o Painel, a Adocao e Engajamento, o Relatorio
         * de Sono - tem isto sempre verdadeiro, e nada muda por la.
         */
        this.applied = false;
        /** `01/09/2026 a 15/09/2026` - o intervalo por extenso, para titulo e PDF. */
        this.rangeLabel = '';
        /** O teto de quem hospeda, quando ha um. Zero significa sem teto. */
        this.maxDays = 0;
        /** Se o intervalo pedido foi encurtado para caber no teto. */
        this.clamped = false;
        this.onFromChanged = Scope.SYNC_ACTION_STRING;
        this.onToChanged = Scope.SYNC_ACTION_STRING;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Array)
], PeriodScope.prototype, "options", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], PeriodScope.prototype, "summary", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], PeriodScope.prototype, "from", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], PeriodScope.prototype, "to", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], PeriodScope.prototype, "applied", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], PeriodScope.prototype, "rangeLabel", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], PeriodScope.prototype, "maxDays", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], PeriodScope.prototype, "clamped", void 0);
PeriodScope = __decorate([
    Observable
], PeriodScope);
export { PeriodScope };
//# sourceMappingURL=period.scope.js.map